import { useCallback } from 'react';

import { usePsfPromoteOrSharePageData } from 'src/app/pages/psf/promoteOrShare/pageContext';
import { useQueryParamValue } from 'src/app/shared/hooks/location';
import {
	usePromotedTrackingData,
	useTrackPromotionShare as useTrackPromotionShareBase,
} from 'src/app/shared/hooks/promotion';

export function useTrackPromotionShare() {
	const trackPromotionShare = useTrackPromotionShareBase();
	const {
		data: {
			petition: { id },
		},
	} = usePsfPromoteOrSharePageData();
	const queryPromotionToken = useQueryParamValue('pt');
	const [localStoragePromotedData] = usePromotedTrackingData(id);

	return useCallback(async () => {
		const token = queryPromotionToken || localStoragePromotedData?.token;
		const placement = localStoragePromotedData?.placement;
		const algorithm = localStoragePromotedData?.algorithm;

		if (!token) return undefined;

		return trackPromotionShare({ token, placement, algorithm }, { silent: true });
	}, [trackPromotionShare, queryPromotionToken, localStoragePromotedData]);
}
